import * as yup from 'yup'

const required = 'This field is required'
const emailError = 'Enter a valid email'

export const validationSchema = yup.object().shape({
  street: yup.string().nullable().required(required),
  city: yup.string().required(required),
  state: yup.string().required(required),
  zip_code: yup.string().required(required),
  property_type: yup.string().nullable(),
  property_usage: yup.string().nullable(),
  use_of_proceeds: yup.array(),
  first_name: yup.string().required(required),
  last_name: yup.string().required(required),
  email: yup.string().email(emailError).required(required),
  phone: yup.number().nullable().required(required),
})
